<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          자동민팅
        </div>
        <div>
          <item-write-auto-component :item-type="'autoItem'"></item-write-auto-component>
          <div class="mt10 text-center">
            <el-button class="reg_btn_out" @click="writeItem()">등록</el-button>
            <el-button class="com_btn" @click="$router.push('/item/list');">목록</el-button>
          </div>
        </div>
      </div>
    </div>
    <item-auto-member-modal></item-auto-member-modal>
  </div>
</template>

<script>

import ItemWriteAutoComponent from "@/components/item/ItemWriteAutoComponent";
import ItemAutoMemberModal from "@/components/modal/ItemAutoMemberModal";
import EventBus from "@/utils/event-bus";

export default {
  name: "Item",
  mixins: [],
  components: {
    ItemAutoMemberModal,
    ItemWriteAutoComponent
  },
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    writeItem() {
      EventBus.$emit('itemAutoWrite');
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
